import React, { useState, useEffect, Fragment } from "react";


const useTechnologiesTable = (
  TechnologyArray,
  handleDelTechnology,
  handleEditTechnology,
  onClickToggleFromTable
) => {
  const [thead] = useState(["Technology Name", "Action"]);
  const [trow, setTrow] = useState([]);

  useEffect(() => {
    let trowArr = TechnologyArray?.map((el) => {
      return {
        "Technology Name": el.technologyName,
        Action: (
          <Fragment>
            <i
              className="fas fa-edit ml-4"              
              onClick={() => {
                handleEditTechnology(el, el.technologyId);
                onClickToggleFromTable();
             }}
            ></i>
            <i
              className="fas fa-trash"
              onClick={() => handleDelTechnology(el.technologyId)}
            ></i>
            
          </Fragment>
        ),
      };
    });

     setTrow(trowArr);
  }, [
    TechnologyArray,
    handleDelTechnology,
    handleEditTechnology,
    onClickToggleFromTable
  ]);

  return { thead, trow };
};

export default useTechnologiesTable;